import exitImg from '@/public/assets/btn-exit.png';
import backArrowImg from '@/public/assets/btn-back-black.png';
import { PayMentType, moveToInvoice } from '@/utils/browser-utils';
import Image from 'next/image';
import styled from '@emotion/styled';
import { AppleSDGothicNeo } from '@/styles/font/AppleSDGothicNeo';
import { getFontFamily } from '@/styles/font';
import { BillDetail } from '@/types/Bill';

interface TopNavigationBarProps {
  title: string;
  titleColor?: string;
  backgroundColor?: string;
  billInfo?: BillDetail;
  org_logo?: string;
  backOnClick: () => void;
  exitOnClick?: () => void;
}

const TopNavigationBarWrapper = styled.nav<{ backgroundColor: string; titleColor: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  color: ${(props) => props.titleColor};
  background-color: ${(props) => props.backgroundColor};
  font-family: ${getFontFamily(AppleSDGothicNeo.Bold)};
  font-size: 18px;
  box-shadow: 0px 0px 4px 0px #8990a0;
  z-index: 100;

  img {
    :first-of-type {
      margin: 5px;
      margin-left: 15px;
    }

    :last-of-type {
      margin: 5px;
      margin-right: 15px;
    }
  }
`;

function TopNavigationBar({
  title,
  titleColor = 'black',
  backgroundColor = 'white',
  backOnClick,
  exitOnClick = () => {moveToInvoice(PayMentType.HOME)},
  org_logo
}: TopNavigationBarProps) {

  return (
    <TopNavigationBarWrapper
      role="toolbar"
      titleColor={titleColor}
      backgroundColor={backgroundColor}
    > 
      <Image src={backArrowImg} alt="back_img" onClick={backOnClick} />
      <div style={{display: "flex", alignItems: "center", paddingTop: "3px"}}>
        {
          org_logo? (
            <Image
                className="citygasLogo"
                alt="citygasLogo"
                width={24}
                height={24}
                src={org_logo!}
                style={{padding: "3px", boxSizing: "border-box", position: "relative", top: "-1px", marginRight: "5px"}}
              />
          ) : null 
        }
        {title}
      </div>
      
      <Image src={exitImg} alt="exit_img" onClick={exitOnClick} />
    </TopNavigationBarWrapper>
  );
}

export default TopNavigationBar;
